// import React, { useState, useEffect } from 'react';
// import Header from '../../components/ui/Header';
// import Sidebar from '../../components/ui/Sidebar';
// import Breadcrumb from '../../components/ui/Breadcrumb';
// import MasterDataTabs from './components/MasterDataTabs';
// import DataTable from './components/DataTable';
// import AddEditModal from './components/AddEditModal';
// import ViewModal from './components/ViewModal';
// import DeleteConfirmModal from './components/DeleteConfirmModal';
// import Icon from '../../components/AppIcon';

// const MasterDataManagement = () => {
//   const [activeTab, setActiveTab] = useState('digital-print-operators');
//   const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
//   const [isViewModalOpen, setIsViewModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [viewData, setViewData] = useState(null);
//   const [deleteData, setDeleteData] = useState(null);
//   const [data, setData] = useState({});
//   const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

//   // Mock data for different categories
//   const mockData = {
//     'digital-print-operators': [
//       {
//         id: 1,
//         name: "Rajesh Kumar",
//         code: "DPO001",
//         contact: {
//           phone: "+91 98765 43210",
//           email: "rajesh.kumar@email.com",
//           address: "123 Industrial Area, Mumbai, Maharashtra 400001"
//         },
//         specialization: "digital-printing",
//         rate: 25,
//         experience: 8,
//         status: "active",
//         createdAt: "2025-01-15T10:30:00Z",
//         updatedAt: "2025-01-20T14:45:00Z"
//       },
//       {
//         id: 2,
//         name: "Priya Sharma",
//         code: "DPO002",
//         contact: {
//           phone: "+91 87654 32109",
//           email: "priya.sharma@email.com",
//           address: "456 Textile Hub, Surat, Gujarat 395001"
//         },
//         specialization: "sublimation",
//         rate: 30,
//         experience: 12,
//         status: "active",
//         createdAt: "2025-01-10T09:15:00Z",
//         updatedAt: "2025-01-18T16:20:00Z"
//       },
//       {
//         id: 3,
//         name: "Amit Patel",
//         code: "DPO003",
//         contact: {
//           phone: "+91 76543 21098",
//           email: "amit.patel@email.com",
//           address: "789 Print Street, Ahmedabad, Gujarat 380001"
//         },
//         specialization: "screen-printing",
//         rate: 22,
//         experience: 6,
//         status: "inactive",
//         createdAt: "2025-01-05T11:00:00Z",
//         updatedAt: "2025-01-12T13:30:00Z"
//       }
//     ],
//     'cutting-specialists': [
//       {
//         id: 1,
//         name: "Sunita Devi",
//         code: "CUT001",
//         contact: {
//           phone: "+91 98765 43211",
//           email: "sunita.devi@email.com",
//           address: "321 Garment Colony, Tirupur, Tamil Nadu 641601"
//         },
//         expertise: "fabric-cutting",
//         rate: 15,
//         experience: 10,
//         status: "active",
//         createdAt: "2025-01-12T08:45:00Z",
//         updatedAt: "2025-01-22T10:15:00Z"
//       },
//       {
//         id: 2,
//         name: "Ramesh Singh",
//         code: "CUT002",
//         contact: {
//           phone: "+91 87654 32110",
//           email: "ramesh.singh@email.com",
//           address: "654 Industrial Zone, Ludhiana, Punjab 141001"
//         },
//         expertise: "pattern-cutting",
//         rate: 18,
//         experience: 15,
//         status: "active",
//         createdAt: "2025-01-08T12:30:00Z",
//         updatedAt: "2025-01-19T15:45:00Z"
//       }
//     ],
//     'raw-material-suppliers': [
//       {
//         id: 1,
//         name: "Gujarat Textiles Ltd",
//         code: "SUP001",
//         contact: {
//           phone: "+91 98765 43212",
//           email: "info@gujarattextiles.com",
//           address: "Plot 15, GIDC Estate, Vapi, Gujarat 396191"
//         },
//         materials: ["cotton", "polyester", "silk"],
//         kgRate: 450,
//         meterRate: 92,
//         conversionRatio: 4.9,
//         paymentTerms: "30 days credit",
//         status: "active",
//         createdAt: "2025-01-01T00:00:00Z",
//         updatedAt: "2025-01-25T09:30:00Z"
//       },
//       {
//         id: 2,
//         name: "Mumbai Fabric House",
//         code: "SUP002",
//         contact: {
//           phone: "+91 87654 32111",
//           email: "sales@mumbaifabric.com",
//           address: "567 Textile Market, Mumbai, Maharashtra 400002"
//         },
//         materials: ["wool", "linen", "rayon"],
//         kgRate: 520,
//         meterRate: 106,
//         conversionRatio: 4.9,
//         paymentTerms: "15 days credit",
//         status: "active",
//         createdAt: "2024-12-15T10:00:00Z",
//         updatedAt: "2025-01-20T14:20:00Z"
//       }
//     ],
//     'clients': [
//       {
//         id: 1,
//         name: "Fashion Forward Pvt Ltd",
//         code: "CLI001",
//         contact: {
//           phone: "+91 98765 43213",
//           email: "orders@fashionforward.com",
//           address: "Tower A, Business Park, Bangalore, Karnataka 560001"
//         },
//         platforms: ["AJIO", "MYNTRA", "OFFLINE"],
//         onlineRate: 180,
//         offlineRate: 150,
//         paymentTerms: "45 days credit",
//         creditLimit: 500000,
//         status: "active",
//         createdAt: "2024-11-20T00:00:00Z",
//         updatedAt: "2025-01-24T11:45:00Z"
//       },
//       {
//         id: 2,
//         name: "Style Studio",
//         code: "CLI002",
//         contact: {
//           phone: "+91 87654 32112",
//           email: "procurement@stylestudio.in",
//           address: "Fashion Street, Delhi, Delhi 110001"
//         },
//         platforms: ["AMAZON", "FLIPKART"],
//         onlineRate: 165,
//         offlineRate: 140,
//         paymentTerms: "30 days credit",
//         creditLimit: 300000,
//         status: "active",
//         createdAt: "2024-12-01T00:00:00Z",
//         updatedAt: "2025-01-21T16:30:00Z"
//       }
//     ],
//     'general-parties': [
//       {
//         id: 1,
//         name: "Logistics Express",
//         code: "GEN001",
//         contact: {
//           phone: "+91 98765 43214",
//           email: "support@logisticsexpress.com",
//           address: "Transport Nagar, Pune, Maharashtra 411001"
//         },
//         type: "Logistics Partner",
//         description: "Transportation and delivery services",
//         status: "active",
//         createdAt: "2024-10-15T00:00:00Z",
//         updatedAt: "2025-01-15T12:00:00Z"
//       },
//       {
//         id: 2,
//         name: "Quality Assurance Services",
//         code: "GEN002",
//         contact: {
//           phone: "+91 87654 32113",
//           email: "info@qualityassurance.com",
//           address: "Industrial Estate, Chennai, Tamil Nadu 600001"
//         },
//         type: "Quality Control",
//         description: "Fabric and garment quality testing",
//         status: "active",
//         createdAt: "2024-11-01T00:00:00Z",
//         updatedAt: "2025-01-18T09:15:00Z"
//       }
//     ],
//     'purchase-invoices': [
//       {
//         id: 1,
//         invoiceNumber: "INV-2025-001",
//         supplier: {
//           id: "sup001",
//           name: "Gujarat Textiles Ltd",
//           code: "SUP001"
//         },
//         invoiceDate: "2025-01-15",
//         dueDate: "2025-02-14",
//         items: [
//           {
//             material: "Cotton Fabric",
//             quantity: 100,
//             rate: 450,
//             amount: 45000
//           },
//           {
//             material: "Polyester Blend",
//             quantity: 50,
//             rate: 520,
//             amount: 26000
//           }
//         ],
//         subtotal: 71000,
//         taxRate: 18,
//         taxAmount: 12780,
//         totalAmount: 83780,
//         paymentTerms: "30 days",
//         notes: "Bulk order for spring collection",
//         status: "pending",
//         createdAt: "2025-01-15T10:30:00Z",
//         updatedAt: "2025-01-15T10:30:00Z"
//       },
//       {
//         id: 2,
//         invoiceNumber: "INV-2025-002",
//         supplier: {
//           id: "sup002",
//           name: "Mumbai Fabric House",
//           code: "SUP002"
//         },
//         invoiceDate: "2025-01-18",
//         dueDate: "2025-02-17",
//         items: [
//           {
//             material: "Silk Fabric",
//             quantity: 75,
//             rate: 800,
//             amount: 60000
//           }
//         ],
//         subtotal: 60000,
//         taxRate: 18,
//         taxAmount: 10800,
//         totalAmount: 70800,
//         paymentTerms: "30 days",
//         notes: "Premium silk for luxury line",
//         status: "paid",
//         createdAt: "2025-01-18T14:20:00Z",
//         updatedAt: "2025-01-20T09:15:00Z"
//       },
//       {
//         id: 3,
//         invoiceNumber: "INV-2025-003",
//         supplier: {
//           id: "sup001",
//           name: "Gujarat Textiles Ltd",
//           code: "SUP001"
//         },
//         invoiceDate: "2025-01-10",
//         dueDate: "2025-02-09",
//         items: [
//           {
//             material: "Denim Fabric",
//             quantity: 200,
//             rate: 380,
//             amount: 76000
//           },
//           {
//             material: "Cotton Lining",
//             quantity: 150,
//             rate: 120,
//             amount: 18000
//           }
//         ],
//         subtotal: 94000,
//         taxRate: 18,
//         taxAmount: 16920,
//         totalAmount: 110920,
//         paymentTerms: "45 days",
//         notes: "Denim collection raw materials",
//         status: "overdue",
//         createdAt: "2025-01-10T08:45:00Z",
//         updatedAt: "2025-01-25T16:30:00Z"
//       }
//     ]
//   };

//   useEffect(() => {
//     setData(mockData);
//   }, []);

//   const tabCounts = {
//     'digital-print-operators': data['digital-print-operators']?.length || 0,
//     'cutting-specialists': data['cutting-specialists']?.length || 0,
//     'raw-material-suppliers': data['raw-material-suppliers']?.length || 0,
//     'clients': data['clients']?.length || 0,
//     'general-parties': data['general-parties']?.length || 0,
//     'purchase-invoices': data['purchase-invoices']?.length || 0,
//   };

//   const handleTabChange = (tabId) => {
//     setActiveTab(tabId);
//   };

//   const handleAddNew = (tabId) => {
//     setEditData(null);
//     setIsAddEditModalOpen(true);
//   };

//   const handleEdit = (item) => {
//     setEditData(item);
//     setIsAddEditModalOpen(true);
//   };

//   const handleView = (item) => {
//     setViewData(item);
//     setIsViewModalOpen(true);
//   };

//   const handleDelete = (item) => {
//     setDeleteData(item);
//     setIsDeleteModalOpen(true);
//   };

//   const handleSave = async (formData) => {
//     // Simulate API call
//     await new Promise(resolve => setTimeout(resolve, 1000));

//     const newData = { ...data };

//     if (editData) {
//       // Update existing item
//       const index = newData[activeTab].findIndex(item => item.id === editData.id);
//       if (index !== -1) {
//         newData[activeTab][index] = {
//           ...formData,
//           id: editData.id,
//           updatedAt: new Date().toISOString()
//         };
//       }
//     } else {
//       // Add new item
//       const newItem = {
//         ...formData,
//         id: Date.now(),
//         createdAt: new Date().toISOString(),
//         updatedAt: new Date().toISOString()
//       };
//       newData[activeTab] = [newItem, ...newData[activeTab]];
//     }

//     setData(newData);
//     setIsAddEditModalOpen(false);
//     setEditData(null);
//   };

//   const handleConfirmDelete = async (item) => {
//     // Simulate API call
//     await new Promise(resolve => setTimeout(resolve, 500));

//     const newData = { ...data };
//     newData[activeTab] = newData[activeTab].filter(dataItem => dataItem.id !== item.id);
//     setData(newData);
//     setIsDeleteModalOpen(false);
//     setDeleteData(null);
//   };

//   const currentData = data[activeTab] || [];

//   return (
//     <div className="min-h-screen bg-background">
//       <Header />
//       <Sidebar onCollapseChange={setIsSidebarCollapsed} />

//       <main className={`
//           transition-all duration-300 pt-16
//           ${isSidebarCollapsed ? 'ml-0 sm:ml-16' : 'ml-0 sm:ml-64'}
//           px-4 sm:px-6 lg:px-8
//           min-h-[calc(100vh-4rem)]
//           relative z-0
//         `}>
//         <div className="flex-1 flex flex-col">
//           <Breadcrumb />

//           {/* Page Header */}
//           <div className="mb-6">
//             <div className="flex items-center space-x-3 mb-2">
//               <Icon name="Database" size={24} className="text-primary" />
//               <h1 className="text-2xl font-bold text-foreground">Master Data Management</h1>
//             </div>
//             <p className="text-muted-foreground">
//               Configure and manage parties, operators, suppliers, and clients for textile operations
//             </p>
//           </div>

//           {/* Stats Cards */}
//           <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 mb-6">
//             <div className="bg-card border border-border rounded-lg p-4">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-sm text-muted-foreground">Print Operators</p>
//                   <p className="text-2xl font-bold text-foreground">{data['digital-print-operators']?.length || 0}</p>
//                 </div>
//                 <Icon name="Printer" size={20} className="text-primary" />
//               </div>
//             </div>
//             <div className="bg-card border border-border rounded-lg p-4">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-sm text-muted-foreground">Cutting Specialists</p>
//                   <p className="text-2xl font-bold text-foreground">{data['cutting-specialists']?.length || 0}</p>
//                 </div>
//                 <Icon name="Scissors" size={20} className="text-primary" />
//               </div>
//             </div>
//             <div className="bg-card border border-border rounded-lg p-4">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-sm text-muted-foreground">Suppliers</p>
//                   <p className="text-2xl font-bold text-foreground">{data['raw-material-suppliers']?.length || 0}</p>
//                 </div>
//                 <Icon name="Truck" size={20} className="text-primary" />
//               </div>
//             </div>
//             <div className="bg-card border border-border rounded-lg p-4">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-sm text-muted-foreground">Clients</p>
//                   <p className="text-2xl font-bold text-foreground">{data['clients']?.length || 0}</p>
//                 </div>
//                 <Icon name="Users" size={20} className="text-primary" />
//               </div>
//             </div>
//             <div className="bg-card border border-border rounded-lg p-4">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-sm text-muted-foreground">General Parties</p>
//                   <p className="text-2xl font-bold text-foreground">{data['general-parties']?.length || 0}</p>
//                 </div>
//                 <Icon name="Building" size={20} className="text-primary" />
//               </div>
//             </div>
//             <div className="bg-card border border-border rounded-lg p-4">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="text-sm text-muted-foreground">Purchase Invoices</p>
//                   <p className="text-2xl font-bold text-foreground">{data['purchase-invoices']?.length || 0}</p>
//                 </div>
//                 <Icon name="Receipt" size={20} className="text-primary" />
//               </div>
//             </div>
//           </div>

//           {/* Main Content */}
//           <div className="space-y-6">
//             <MasterDataTabs
//               activeTab={activeTab}
//               onTabChange={handleTabChange}
//               onAddNew={handleAddNew}
//             />

//             <DataTable
//               activeTab={activeTab}
//               data={currentData}
//               onEdit={handleEdit}
//               onDelete={handleDelete}
//               onView={handleView}
//             />
//           </div>
//         </div>
//       </main>

//       {/* Modals */}
//       <AddEditModal
//         isOpen={isAddEditModalOpen}
//         onClose={() => {
//           setIsAddEditModalOpen(false);
//           setEditData(null);
//         }}
//         activeTab={activeTab}
//         editData={editData}
//         onSave={handleSave}
//       />

//       <ViewModal
//         isOpen={isViewModalOpen}
//         onClose={() => {
//           setIsViewModalOpen(false);
//           setViewData(null);
//         }}
//         data={viewData}
//         activeTab={activeTab}
//       />

//       <DeleteConfirmModal
//         isOpen={isDeleteModalOpen}
//         onClose={() => {
//           setIsDeleteModalOpen(false);
//           setDeleteData(null);
//         }}
//         data={deleteData}
//         onConfirm={handleConfirmDelete}
//       />
//     </div>
//   );
// };

// export default MasterDataManagement;












import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import Sidebar from '../../components/ui/Sidebar';
import Breadcrumb from '../../components/ui/Breadcrumb';
import MasterDataTabs from './components/MasterDataTabs';
import DataTable from './components/DataTable';
import AddEditModal from './components/AddEditModal';
import ViewModal from './components/ViewModal';
import DeleteConfirmModal from './components/DeleteConfirmModal';
import Icon from '../../components/AppIcon';

const MasterDataManagement = () => {
  const [activeTab, setActiveTab] = useState('digital-print-operators');
  const [isAddEditModalOpen, setIsAddEditModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [deleteData, setDeleteData] = useState(null);
  const [data, setData] = useState({});
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);

  // Mock data for different categories
  const mockData = {
    'digital-print-operators': [
      {
        id: 1,
        name: "Rajesh Kumar",
        code: "DPO001",
        contact: {
          phone: "+91 98765 43210",
          email: "rajesh.kumar@email.com",
          address: "123 Industrial Area, Mumbai, Maharashtra 400001"
        },
        specialization: "digital-printing",
        rate: 25,
        experience: 8,
        status: "active",
        createdAt: "2025-01-15T10:30:00Z",
        updatedAt: "2025-01-20T14:45:00Z"
      },
      {
        id: 2,
        name: "Priya Sharma",
        code: "DPO002",
        contact: {
          phone: "+91 87654 32109",
          email: "priya.sharma@email.com",
          address: "456 Textile Hub, Surat, Gujarat 395001"
        },
        specialization: "sublimation",
        rate: 30,
        experience: 12,
        status: "active",
        createdAt: "2025-01-10T09:15:00Z",
        updatedAt: "2025-01-18T16:20:00Z"
      },
      {
        id: 3,
        name: "Amit Patel",
        code: "DPO003",
        contact: {
          phone: "+91 76543 21098",
          email: "amit.patel@email.com",
          address: "789 Print Street, Ahmedabad, Gujarat 380001"
        },
        specialization: "screen-printing",
        rate: 22,
        experience: 6,
        status: "inactive",
        createdAt: "2025-01-05T11:00:00Z",
        updatedAt: "2025-01-12T13:30:00Z"
      }
    ],
    'cutting-specialists': [
      {
        id: 1,
        name: "Sunita Devi",
        code: "CUT001",
        contact: {
          phone: "+91 98765 43211",
          email: "sunita.devi@email.com",
          address: "321 Garment Colony, Tirupur, Tamil Nadu 641601"
        },
        expertise: "fabric-cutting",
        rate: 15,
        experience: 10,
        status: "active",
        createdAt: "2025-01-12T08:45:00Z",
        updatedAt: "2025-01-22T10:15:00Z"
      },
      {
        id: 2,
        name: "Ramesh Singh",
        code: "CUT002",
        contact: {
          phone: "+91 87654 32110",
          email: "ramesh.singh@email.com",
          address: "654 Industrial Zone, Ludhiana, Punjab 141001"
        },
        expertise: "pattern-cutting",
        rate: 18,
        experience: 15,
        status: "active",
        createdAt: "2025-01-08T12:30:00Z",
        updatedAt: "2025-01-19T15:45:00Z"
      }
    ],
    'raw-material-suppliers': [
      {
        id: 1,
        name: "Gujarat Textiles Ltd",
        code: "SUP001",
        contact: {
          phone: "+91 98765 43212",
          email: "info@gujarattextiles.com",
          address: "Plot 15, GIDC Estate, Vapi, Gujarat 396191"
        },
        materials: ["cotton", "polyester", "silk"],
        kgRate: 450,
        meterRate: 92,
        conversionRatio: 4.9,
        paymentTerms: "30 days credit",
        status: "active",
        createdAt: "2025-01-01T00:00:00Z",
        updatedAt: "2025-01-25T09:30:00Z"
      },
      {
        id: 2,
        name: "Mumbai Fabric House",
        code: "SUP002",
        contact: {
          phone: "+91 87654 32111",
          email: "sales@mumbaifabric.com",
          address: "567 Textile Market, Mumbai, Maharashtra 400002"
        },
        materials: ["wool", "linen", "rayon"],
        kgRate: 520,
        meterRate: 106,
        conversionRatio: 4.9,
        paymentTerms: "15 days credit",
        status: "active",
        createdAt: "2024-12-15T10:00:00Z",
        updatedAt: "2025-01-20T14:20:00Z"
      }
    ],
    'clients': [
      {
        id: 1,
        name: "Fashion Forward Pvt Ltd",
        code: "CLI001",
        contact: {
          phone: "+91 98765 43213",
          email: "orders@fashionforward.com",
          address: "Tower A, Business Park, Bangalore, Karnataka 560001"
        },
        platforms: ["AJIO", "MYNTRA", "OFFLINE"],
        onlineRate: 180,
        offlineRate: 150,
        paymentTerms: "45 days credit",
        creditLimit: 500000,
        status: "active",
        createdAt: "2024-11-20T00:00:00Z",
        updatedAt: "2025-01-24T11:45:00Z"
      },
      {
        id: 2,
        name: "Style Studio",
        code: "CLI002",
        contact: {
          phone: "+91 87654 32112",
          email: "procurement@stylestudio.in",
          address: "Fashion Street, Delhi, Delhi 110001"
        },
        platforms: ["AMAZON", "FLIPKART"],
        onlineRate: 165,
        offlineRate: 140,
        paymentTerms: "30 days credit",
        creditLimit: 300000,
        status: "active",
        createdAt: "2024-12-01T00:00:00Z",
        updatedAt: "2025-01-21T16:30:00Z"
      }
    ],
    'general-parties': [
      {
        id: 1,
        name: "Logistics Express",
        code: "GEN001",
        contact: {
          phone: "+91 98765 43214",
          email: "support@logisticsexpress.com",
          address: "Transport Nagar, Pune, Maharashtra 411001"
        },
        type: "Logistics Partner",
        description: "Transportation and delivery services",
        status: "active",
        createdAt: "2024-10-15T00:00:00Z",
        updatedAt: "2025-01-15T12:00:00Z"
      },
      {
        id: 2,
        name: "Quality Assurance Services",
        code: "GEN002",
        contact: {
          phone: "+91 87654 32113",
          email: "info@qualityassurance.com",
          address: "Industrial Estate, Chennai, Tamil Nadu 600001"
        },
        type: "Quality Control",
        description: "Fabric and garment quality testing",
        status: "active",
        createdAt: "2024-11-01T00:00:00Z",
        updatedAt: "2025-01-18T09:15:00Z"
      }
    ],
    'purchase-invoices': [
      {
        id: 1,
        invoiceNumber: "INV-2025-001",
        name: "INV-2025-001", // Added for table compatibility
        code: "INV-2025-001", // Added for table compatibility
        supplier: {
          id: "sup001",
          name: "Gujarat Textiles Ltd",
          code: "SUP001"
        },
        invoiceDate: "2025-01-15",
        dueDate: "2025-02-14",
        items: [
          {
            material: "Cotton Fabric",
            quantity: 100,
            rate: 450,
            amount: 45000
          },
          {
            material: "Polyester Blend",
            quantity: 50,
            rate: 520,
            amount: 26000
          }
        ],
        subtotal: 71000,
        taxRate: 18,
        taxAmount: 12780,
        totalAmount: 83780,
        paymentTerms: "30 days",
        notes: "Bulk order for spring collection",
        status: "pending",
        createdAt: "2025-01-15T10:30:00Z",
        updatedAt: "2025-01-15T10:30:00Z"
      },
      {
        id: 2,
        invoiceNumber: "INV-2025-002",
        name: "INV-2025-002", // Added for table compatibility
        code: "INV-2025-002", // Added for table compatibility
        supplier: {
          id: "sup002",
          name: "Mumbai Fabric House",
          code: "SUP002"
        },
        invoiceDate: "2025-01-18",
        dueDate: "2025-02-17",
        items: [
          {
            material: "Silk Fabric",
            quantity: 75,
            rate: 800,
            amount: 60000
          }
        ],
        subtotal: 60000,
        taxRate: 18,
        taxAmount: 10800,
        totalAmount: 70800,
        paymentTerms: "30 days",
        notes: "Premium silk for luxury line",
        status: "paid",
        createdAt: "2025-01-18T14:20:00Z",
        updatedAt: "2025-01-20T09:15:00Z"
      },
      {
        id: 3,
        invoiceNumber: "INV-2025-003",
        name: "INV-2025-003", // Added for table compatibility
        code: "INV-2025-003", // Added for table compatibility
        supplier: {
          id: "sup001",
          name: "Gujarat Textiles Ltd",
          code: "SUP001"
        },
        invoiceDate: "2025-01-10",
        dueDate: "2025-02-09",
        items: [
          {
            material: "Denim Fabric",
            quantity: 200,
            rate: 380,
            amount: 76000
          },
          {
            material: "Cotton Lining",
            quantity: 150,
            rate: 120,
            amount: 18000
          }
        ],
        subtotal: 94000,
        taxRate: 18,
        taxAmount: 16920,
        totalAmount: 110920,
        paymentTerms: "45 days",
        notes: "Denim collection raw materials",
        status: "overdue",
        createdAt: "2025-01-10T08:45:00Z",
        updatedAt: "2025-01-25T16:30:00Z"
      }
    ]
  };

  useEffect(() => {
    setData(mockData);
  }, []);

  const tabCounts = {
    'digital-print-operators': data['digital-print-operators']?.length || 0,
    'cutting-specialists': data['cutting-specialists']?.length || 0,
    'raw-material-suppliers': data['raw-material-suppliers']?.length || 0,
    'clients': data['clients']?.length || 0,
    'general-parties': data['general-parties']?.length || 0,
    'purchase-invoices': data['purchase-invoices']?.length || 0,
  };

  const handleTabChange = (tabId) => {
    setActiveTab(tabId);
  };

  const handleAddNew = (tabId) => {
    setEditData(null);
    setIsAddEditModalOpen(true);
  };

  const handleEdit = (item) => {
    setEditData(item);
    setIsAddEditModalOpen(true);
  };

  const handleView = (item) => {
    setViewData(item);
    setIsViewModalOpen(true);
  };

  const handleDelete = (item) => {
    setDeleteData(item);
    setIsDeleteModalOpen(true);
  };

  const handleSave = async (formData) => {
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));

      const newData = { ...data };

      if (editData) {
        // Update existing item
        const index = newData[activeTab].findIndex(item => item.id === editData.id);
        if (index !== -1) {
          newData[activeTab][index] = {
            ...formData,
            id: editData.id,
            updatedAt: new Date().toISOString()
          };
        }
      } else {
        // Add new item
        const newItem = {
          ...formData,
          id: Date.now(),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString()
        };

        // For purchase invoices, add required fields for table compatibility
        if (activeTab === 'purchase-invoices') {
          newItem.name = newItem.invoiceNumber || `INV-${Date.now()}`;
          newItem.code = newItem.invoiceNumber || `INV-${Date.now()}`;
        }

        newData[activeTab] = [newItem, ...newData[activeTab]];
      }

      setData(newData);
      setIsAddEditModalOpen(false);
      setEditData(null);
    } catch (error) {
      console.error('Error saving data:', error);
      // Handle error appropriately
    }
  };

  const handleConfirmDelete = async (item) => {
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 500));

      const newData = { ...data };
      newData[activeTab] = newData[activeTab].filter(dataItem => dataItem.id !== item.id);
      setData(newData);
      setIsDeleteModalOpen(false);
      setDeleteData(null);
    } catch (error) {
      console.error('Error deleting data:', error);
      // Handle error appropriately
    }
  };

  const currentData = data[activeTab] || [];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Sidebar onCollapseChange={setIsSidebarCollapsed} />

      <main className={`
          transition-all duration-300 pt-16
          ${isSidebarCollapsed ? 'ml-0 sm:ml-16' : 'ml-0 sm:ml-64'}
          px-4 sm:px-6 lg:px-8
          min-h-[calc(100vh-4rem)]
          relative z-0
        `}>
        <div className="flex-1 flex flex-col mb-8">
          <Breadcrumb />

          {/* Page Header */}
          <div className="mb-6">
            <div className="flex items-center space-x-3 mb-2">
              <Icon name="Database" size={24} className="text-primary" />
              <h1 className="text-2xl font-bold text-foreground">Master Data Management</h1>
            </div>
            <p className="text-muted-foreground">
              Configure and manage parties, operators, suppliers, and clients for textile operations
            </p>
          </div>

          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-4 mb-6">
            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">Print Operators</p>
                  <p className="text-2xl font-bold text-foreground">{data['digital-print-operators']?.length || 0}</p>
                </div>
                <Icon name="Printer" size={20} className="text-primary" />
              </div>
            </div>
            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">Cutting Specialists</p>
                  <p className="text-2xl font-bold text-foreground">{data['cutting-specialists']?.length || 0}</p>
                </div>
                <Icon name="Scissors" size={20} className="text-primary" />
              </div>
            </div>
            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">Suppliers</p>
                  <p className="text-2xl font-bold text-foreground">{data['raw-material-suppliers']?.length || 0}</p>
                </div>
                <Icon name="Truck" size={20} className="text-primary" />
              </div>
            </div>
            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">Clients</p>
                  <p className="text-2xl font-bold text-foreground">{data['clients']?.length || 0}</p>
                </div>
                <Icon name="Users" size={20} className="text-primary" />
              </div>
            </div>
            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">General Parties</p>
                  <p className="text-2xl font-bold text-foreground">{data['general-parties']?.length || 0}</p>
                </div>
                <Icon name="Building" size={20} className="text-primary" />
              </div>
            </div>
            <div className="bg-card border border-border rounded-lg p-4">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-muted-foreground">Purchase Invoices</p>
                  <p className="text-2xl font-bold text-foreground">{data['purchase-invoices']?.length || 0}</p>
                </div>
                <Icon name="Receipt" size={20} className="text-primary" />
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="space-y-6">
            <MasterDataTabs
              activeTab={activeTab}
              onTabChange={handleTabChange}
              onAddNew={handleAddNew}
            />

            <DataTable
              activeTab={activeTab}
              data={currentData}
              onEdit={handleEdit}
              onDelete={handleDelete}
              onView={handleView}
            />
          </div>
        </div>
      </main>

      {/* Modals */}
      <AddEditModal
        isOpen={isAddEditModalOpen}
        onClose={() => {
          setIsAddEditModalOpen(false);
          setEditData(null);
        }}
        activeTab={activeTab}
        editData={editData}
        onSave={handleSave}
      />

      <ViewModal
        isOpen={isViewModalOpen}
        onClose={() => {
          setIsViewModalOpen(false);
          setViewData(null);
        }}
        data={viewData}
        activeTab={activeTab}
      />

      <DeleteConfirmModal
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setDeleteData(null);
        }}
        data={deleteData}
        onConfirm={handleConfirmDelete}
      />
    </div>
  );
};

export default MasterDataManagement;